import { apiGet } from '../shared/utils/apiClient'
import { API_CONFIG } from './config/api'
import type {
  BoxCollectionDto,
  BoxCollectionSettingsDto,
  FindAllBoxCollectionsResponseDto,
} from '../types/generated'

// Re-export types for convenience
export type { BoxCollectionDto, BoxCollectionSettingsDto }

export async function getActiveBoxCollections(): Promise<BoxCollectionDto[]> {
  // Protected endpoint - requires authentication
  const response = await apiGet(API_CONFIG.endpoints.boxCollections.getActive)

  if (!response.ok) {
    throw new Error(
      `Failed to fetch active box collections: ${response.status} ${response.statusText}`,
    )
  }

  const json: FindAllBoxCollectionsResponseDto = await response.json()
  return json.data
}
